(function() {
  var tooltip = document.createElement('div');
  tooltip.id = 'bh-tooltip';
  tooltip.style.cssText = 'position:fixed;background:#1a1a1a;color:#fff;font-size:11px;font-weight:600;padding:4px 8px;border-radius:4px;pointer-events:none;opacity:0;transition:opacity 0.2s ease;z-index:2147483647;white-space:nowrap;';
  document.body.appendChild(tooltip);

  document.addEventListener('mouseover', function(e) {
    var badge = e.target.closest('.bh-badge[data-tooltip]');
    if (!badge) return;
    var text = badge.getAttribute('data-tooltip');
    if (!text) return;
    tooltip.textContent = text;
    tooltip.style.opacity = '1';
  });

  document.addEventListener('mousemove', function(e) {
    tooltip.style.left = (e.clientX + 12) + 'px';
    tooltip.style.top = (e.clientY - 28) + 'px';
  });

  document.addEventListener('mouseout', function(e) {
    if (!e.target.closest('.bh-badge[data-tooltip]')) return;
    tooltip.style.opacity = '0';
  });
})();

// ===== STOCK INDICATOR =====
function bhStockRender(item) {
  if (item.querySelector('.bh-stock')) return;

  var management = item.getAttribute('data-stock-management');
  if (management !== 'shopify') return;

  var qty = parseInt(item.getAttribute('data-stock-qty') || '0');
  var policy = item.getAttribute('data-stock-policy');

  var dot = '', label = '', labelClass = '';

  if (qty <= 0 && policy === 'continue') {
    dot = 'bh-stock__dot--preorder'; label = 'PreOrdine';
  } else if (qty <= 0) {
    dot = 'bh-stock__dot--out'; label = 'Esaurito';
  } else if (qty <= 3) {
    dot = 'bh-stock__dot--low';
    label = 'Ultimi ' + qty + ' disponibili!';
    labelClass = 'bh-stock__label--low';
  } else {
    dot = 'bh-stock__dot--ok'; label = 'Disponibile';
  }

  var html = '<div class="bh-stock">' +
    '<span class="bh-stock__dot ' + dot + '"></span>' +
    '<span class="bh-stock__label ' + labelClass + '">' + label + '</span>' +
    '</div>';

  var priceEl = item.querySelector('.card-price, .price');
  if (priceEl) priceEl.insertAdjacentHTML('afterend', html);
}

function bhStockInit() {
  document.querySelectorAll('.product-item[data-stock-management]:not([data-stock-init])').forEach(function(item) {
    item.setAttribute('data-stock-init', '1');
    bhStockRender(item);
  });
}

setTimeout(bhStockInit, 300);
var bhStockObserver = new MutationObserver(function() {
  clearTimeout(window._bhStockTimer);
  window._bhStockTimer = setTimeout(bhStockInit, 300);
});
bhStockObserver.observe(document.body, { childList: true, subtree: true });

// ===== PRONTA CONSEGNA =====
function bhProntaConsegnaInit() {
  document.querySelectorAll('.product-item[data-pronta-consegna="true"]:not([data-pc-init])').forEach(function(item) {
    item.setAttribute('data-pc-init', '1');
    var btn = item.querySelector('.card-action button');
    if (!btn) return;
    if (btn.querySelector('.bh-pc-icon')) return;
    var icon = document.createElement('span');
    icon.className = 'bh-pc-icon';
    icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="28" height="28" fill="currentColor"><path d="M57.8 23.4l-7.2-8.6A3 3 0 0 0 48 13.8H40V10a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h4.3a7 7 0 0 0 13.4 0h18.6a7 7 0 0 0 13.4 0H58a2 2 0 0 0 2-2V25.8a3 3 0 0 0-.2-2.4zM15 47a3 3 0 1 1-3-3 3 3 0 0 1 3 3zm34 0a3 3 0 1 1-3-3 3 3 0 0 1 3 3zM40 30V18h8l6 8v4z"/><text x="8" y="26" font-size="14" font-weight="bold" fill="white" font-family="Arial">24h</text></svg>';
    btn.appendChild(icon);
  });
}

setTimeout(bhProntaConsegnaInit, 600);
var bhPCObserver = new MutationObserver(function() {
  clearTimeout(window._bhPCTimer);
  window._bhPCTimer = setTimeout(bhProntaConsegnaInit, 300);
});
bhPCObserver.observe(document.body, { childList: true, subtree: true });